
// import { useMemo } from "react";

// // porp-types is a library for typechecking of props
// import PropTypes from "prop-types";

// // react-chartjs-2 components
// import { Bar } from "react-chartjs-2";

// // @mui material components
// import Card from "@mui/material/Card";
// import Divider from "@mui/material/Divider";
// import Icon from "@mui/material/Icon";

// // Material Dashboard 2 React components
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";

// // ReportsBarChart configurations
// import configs from "examples/Charts/BarCharts/ReportsBarChart/configs";

// function ReportsBarChart({ color, title, description, date, chart }) {
//   const { data, options } = configs(chart.labels || [], chart.datasets || {});

//   return (
//     <Card sx={{ height: "100%" }}>
//       <MDBox padding="1rem">
//         {useMemo(
//           () => (
//             <MDBox
//               variant="gradient"
//               bgColor={color}
//               borderRadius="lg"
//               coloredShadow={color}
//               py={2}
//               pr={0.5}
//               mt={-5}
//               height="12.5rem"
//             // height="12.5rem"
//             >
//               <Bar data={data} options={options} />
//             </MDBox>
//           ),
//           [chart, color]
//         )}
//         <MDBox pt={3} pb={1} px={1}>
//           <MDTypography variant="h6" textTransform="capitalize">
//             {title}
//           </MDTypography>
//           {/* <MDTypography component="div" variant="button" color="text" fontWeight="light">
//             {description}
//           </MDTypography> */}
//           {/* <Divider /> */}
//           {/* <MDBox display="flex" alignItems="center">
//             <MDTypography variant="button" color="text" lineHeight={1} sx={{ mt: 0.15, mr: 0.5 }}>
//               <Icon>schedule</Icon>
//             </MDTypography>
//             <MDTypography variant="button" color="text" fontWeight="light">
//               {date}
//             </MDTypography>
//           </MDBox> */}
//         </MDBox>
//       </MDBox>
//     </Card>
//   );
// }

// // Setting default values for the props of ReportsBarChart
// ReportsBarChart.defaultProps = {
//   color: "dark",
//   description: "",
// };

// // Typechecking props for the ReportsBarChart
// ReportsBarChart.propTypes = {
//   color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
//   title: PropTypes.string.isRequired,
//   description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
//   date: PropTypes.string.isRequired,
//   chart: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.array, PropTypes.object])).isRequired,
// };

// export default ReportsBarChart;







import { memo, useMemo } from "react";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import configs from "examples/Charts/BarCharts/ReportsBarChart/configs";
import { useCallback } from "react";

function ReportsBarChart({ color, title, chart }) {
  // console.log("Rendering ReportsBarChart");
  const { data, options } = useMemo(() => configs(chart.labels || [], chart.datasets || {}), [chart]);

  const formatValue = useCallback((value) => {
    if (value >= 1000000000) {
      return (value / 1000000000).toFixed(2) + "B";
    } else if (value >= 1000000) {
      return (value / 1000000).toFixed(2) + "M";
    } else if (value >= 1000) {
      return (value / 1000).toFixed(2) + "K";
    } else {
      return value.toFixed(2);
    }
  }, []);
  const customOptions = useMemo(() => ({
    ...options,
    scales: {
      y: {
        ticks: {
          minFontSize: 10,
          maxFontSize: 12,
          color: 'white',
          stepSize: 5000000,
          callback: formatValue
        },
      },
      x: {
        ticks: {
          minFontSize: 10,
          maxFontSize: 14,
          color: 'white',
        },
      },
    },
  }), [formatValue, options]);
  // options.scales = useMemo(() => (
  //   {
  //     y: {
  //       ticks: {
  //         minFontSize: 10,
  //         maxFontSize: 12,
  //         color: 'white',

  //         stepSize: 5000000,
  //         callback: function (value) {
  //           return formatValue(value);
  //         }
  //       },
  //     },
  //     x: {
  //       ticks: {
  //         minFontSize: 10,
  //         maxFontSize: 14,
  //         color: 'white', // Set font color to white

  //       },
  //     },
  //   }
  // ), [formatValue]);

  return (

    <Card sx={{ height: "100%" }} >
      <MDBox padding="1rem">
        <MDBox variant="gradient" bgColor={color} borderRadius="lg" coloredShadow={color} py={2} pr={0.5} mt={-5}
          height="12.5rem" >
          <Bar style={{ fontSize: "12px" }} data={data} options={customOptions} />
        </MDBox>
        <MDBox pt={3} pb={1} px={1}>
          <MDTypography variant="h6" textTransform="capitalize" >
            {title}
          </MDTypography>
        </MDBox>
      </MDBox>
    </Card>

  );
}

ReportsBarChart.defaultProps = {
  color: "dark",
};

ReportsBarChart.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  title: PropTypes.string.isRequired,
  chart: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.array, PropTypes.object])).isRequired,
};

export default memo(ReportsBarChart);